import { PDFDownloadLink, usePDF } from "@react-pdf/renderer";
import { TriggerGoogleAnalytics4Tag, TriggerGoogleAnalyticsTag } from "../../core/utils/GoogleAnalyticTag";
import { GoogleAnalyticTags } from "../../core/utils/GoogleAnalyticTag/GoogleAnalyticsTags";
import { GoogleAnalytics4Tags } from "../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags";
import PDFSeriesTable from "../../components/organisms/APSeriesTable/utils/pdf";

export const PDFLink = (props) => {
    const { settings, results, translate, affiliateDetails, classes } = props;
    const PDF = () => (
        <PDFSeriesTable
            org={settings.ORG_CODE}
            logo={settings.LOGO_PNG}
            series={results.table}
            title={translate('account.section.annualsummary.title')}
            translate={translate}
            viewType={'accountView'}
            affiliateData={affiliateDetails?.affiliate}
        />
    );

    const [pdf] = usePDF({
        document: <PDF />,
    });

    return (
        <div className={classes.downloadButtons}>
            {results && results.table && (
                <PDFDownloadLink document={<PDF />} fileName="account.pdf">
                    {pdf.blob ? 'PDF' : 'Loading...'}
                </PDFDownloadLink>
            )}
            {
                TriggerGoogleAnalyticsTag(
                    GoogleAnalyticTags.eventAction.click,
                    GoogleAnalyticTags.accounts.click.annualSummaryDownload
                )
            }
            {
                TriggerGoogleAnalytics4Tag(
                    GoogleAnalytics4Tags.accounts.name,
                    GoogleAnalytics4Tags.eventAction.click,
                    GoogleAnalytics4Tags.accounts.click.annualSummaryDownload
                )
            }
        </div>
    )
}

